var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFVentre3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 178,
    viewBox: "0 0 111 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2856 0.114014C102.276 17.1402 98.1607 34.3702 93.6511 52.4416C90.7652 64.1298 87.761 75.8838 86.8406 87.5392C84.2045 120.06 108.317 143.778 109.849 175.194",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21614 89.5178C9.21614 89.5178 -6.37697 134.912 7.42149 151.969",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.86 3.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5331 0.771484C28.8598 10.8031 16.3368 26.2121 12.7343 33.1015C9.1318 39.9909 8.45472 43.074 8.77683 46.8802C9.09895 50.6865 9.18431 51.418 11.505 56.3925C13.8256 61.3671 18.6338 68.6742 18.769 76.2652C18.9043 83.8562 16.8199 96.4172 13.9373 106.235C11.0547 116.053 8.03319 130.737 14.7415 144.852C21.4498 158.968 29.7407 165.361 29.7407 177.114",
    stroke: "#909090",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFVentre3);
export default __webpack_public_path__ + "static/media/F-VENTRE_3.131d477b1141ad536a32b2a22d52f3d7.svg";
export { ForwardRef as ReactComponent };